module.exports = __webpack_public_path__ + "static/media/logo_large.b91ea5d5.png";